import yup from '../../../config/yup';

export const ethosGraphQLReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('ethosGraphQLReader'),
  delayedRead: yup.boolean(),
  connectionKey: yup.string(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  properties: yup.object().shape({
    apiKey: yup.string(),
    rootUrl: yup.string(),
    query: yup.string().required('Query is required'),
    variables: yup.string(),
    path: yup.string().required('Path is required'),
    accessTokenExpirationMinutes: yup.string(),
  }),
});
